var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('PosterList',{attrs:{"currentPage":_vm.currentPage,"displayImg":_vm.displayImg,"isShowImg":_vm.isShowImg,"posterList":_vm.posterList}}),(_vm.isShowImg)?_c('PosterDetail',{attrs:{"page":_vm.currentPage,"isShow":_vm.dismissSilder,"someList":_vm.posterList}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }